import React from 'react'
import PropTypes from 'prop-types'
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    root: props => (
        {
            display: "flex",
            flexDirection: "row",

            justifyContent: "stretch",

        }
    ),
    in_stock: props => (
        {
            fontSize: 18,
            color:theme.palette.success.main
        }
    ),
    out_stock: props => (
        {
            fontSize: 18,
            color:theme.palette.error.main
        }
    )

}))

const ProductStock = props => {
    const { stock_status, stock_quantity, manage_stock } = props
    const classes = useStyles(props);
    return (
        <Box className={classes.root} >
            { manage_stock
                ? <React.Fragment>
                    <Typography variant="subtitle2" gutterBottom>STOCK:</Typography>
                    <Typography  variant="subtitle2">
                        {
                            stock_quantity === 0 ? <RemoveShoppingCartIcon className={classes.out_stock} /> : <ShoppingCartIcon className={classes.in_stock} />
                        }
                    </Typography>
                </React.Fragment>
                : null
            }
        </Box>
    )
}

ProductStock.propTypes = {

}

export default ProductStock
